<template>
    <ul class="nav nav-pills flex-column navbar-nav"
        style=" padding-bottom: 10px; padding-top: 10px; list-style-type: none; background-color: #f8f8f8; ">
        <li style="padding-bottom: 10px; padding-top: 10px; list-style-type: none;" :class="getClassType(sectionName)">
            <a href="#" @click="tabClick(sectionName)"
               class="ajax" style="font-family: 'Montserrat', sans-serif; text-transform: uppercase ">
                <!--<i class="fas fa-plug"></i>-->

                <span style="padding-left: 10px"><svgicon :icon="getIcon(sectionName)" :color="getSvgColor(sectionName)"
                                                          width="35" height="35">
                    <!--color="#8A1F03"--></svgicon></span>
                <div :class="getMenuItemClass(sectionName)" style="margin-left: 5px; ">
                    {{sectionName.replace(/_/g, " ").replace(/AND/g, '&')}}
                </div>
            </a>
            <ul :class="activeClass('poo')" :style="displayType(1)" :id="toIdString(sectionName)"
                v-if="hasSubSection(sectionName)">
                <li :class="getLineItemClass(sectionName)" v-for="member in listItems">
                    <a href="#" @click="subMenuClick(member.name)"
                       :class="getLineItemLinkClass(sectionName)"
                       style="padding-left: 15px">{{titleCase(member.name).replace(/And/g, '&')}}</a>
                </li>
            </ul>
        </li>
    </ul>
</template>

<script>
import {faChessQueen} from '@fortawesome/free-solid-svg-icons'
import Bus from "../eventBus";
import '../compiled-icons'

export default {
  name: 'TabHeaderHome',
  props: {
    value: Array,
    section: String,
    surveyKey: String
  },
  component: {},
  data() {
    return {
      listItems: this.value,
                sectionName: this.section
            }
        },
        computed:
            {
                queen() {
                    return faChessQueen
                }
            }
        ,
        methods: {
            capitalize: function (str) {
                if (str.length === 0) return str;
                return str[0].toUpperCase() + str.substr(1);
            },

            titleCase: function (str) {
                str = str.toLowerCase();
                return str.split(' ').map(this.capitalize).join(' ');
            },
            activeClass: function (...names) {
                for (let name of names) {
                    if (name === this.$route.name)
                        return 'sub-menu active';
                }
                return 'sub-menu';
            },
            getMenuItemClass: function (menuItemName) {
                return "d-inline " + menuItemName.toLowerCase();
            },
            getSvgColor: function (sectionName) {
                let iconColor = '';
                switch (sectionName) {
                    case 'LEADERSHIP_AND_ENGAGEMENT':
                        iconColor = "#8A1F03";
                        break;
                    case 'ENERGY_EFFICIENCY':
                        iconColor = "#DE772B";
                        break;
                    case 'WATER_EFFICIENCY':
                        iconColor = "#9CC0B8";
                        break;
                    case 'WASTE_REDUCTION':
                        iconColor = "#E2C946";
                        break;
                    case 'POLLUTION_PREVENTION':
                        iconColor = "#A7AA61";
                        break;
                    case 'EQUITY_AND_COMMUNITY':
                        iconColor = "#505C13";
                        break;
                    case 'STORM_AND_WASTE_WATER':
                        iconColor = "#5A7572";
                        break;
                    default:
                        break;
                }
                return iconColor;
            },
            getProgressBarClass: function (sectionName) {
                return "progress-bar progress-background " + sectionName.toLowerCase() + "_progress";
            },
            getClassType: function (groupName) {
                return groupName.toLowerCase().replace(/_/g, "-") + "-group nav-item";
            },
            getLineItemClass: function (sectionName) {
                return sectionName.toLowerCase() + "-line-item";
            },
            getLineItemLinkClass: function (sectionName) {
                return "ajax " + sectionName.toLowerCase() + "-line-item";
            },
            getIcon: function (sectionName) {
                let iconValue = '';
                switch (sectionName) {
                    case 'LEADERSHIP_AND_ENGAGEMENT':
                        iconValue = "icon-winery";
                        break;
                    case 'ENERGY_EFFICIENCY':
                        iconValue = "icon-energy_use";
                        break;
                    case 'WATER_EFFICIENCY':
                        iconValue = "icon-winemaking_barrel";
                        break;
                    case 'WASTE_REDUCTION':
                        iconValue = "icon-product";
                        break;
                    case 'POLLUTION_PREVENTION':
                        iconValue = "icon-mountains";
                        break;
                    case 'EQUITY_AND_COMMUNITY':
                        iconValue = "iStock-866715034";
                        break;
                    case 'STORM_AND_WASTE_WATER':
                        iconValue = "icon-rain";
                        break;
                    default:
                        break;
                }
                return iconValue;
            },
            toIdString: function (idCandidate) {
                return idCandidate.toUpperCase().replace(" ", "_");
            },
            displayType: function (...names) {
                for (let name of names) {
                    if (name == this.$route.name)
                        return 'list-style-type: none; font-family: Montserrat, sans-serif; padding-right: 0px;';
                }
                return 'display: none; list-style-type: none; color: black; font-family: Montserrat, sans-serif; padding-right: 0px;';
            },
            triggerMessage: function (pageName) {
                document.getElementById(pageName).style.display = "initial";
            },
            onCollapse(collapsed) {
                //console.log(collapsed)
                this.collapsed = collapsed
            },
            onItemClick(event, item) {
                //console.log('onItemClick' + event.name() + item.name)
            },
            closeAllSubmenus: function () {
                let submenus = document.querySelectorAll(".sub-menu");
                submenus.forEach(val => {
                    val.style.display = "none";
                });
            },
            highlightMenuItem: function (section) {
                let menuBlock = document.querySelector("." + section.toLowerCase().replace(/_/g, "-") + "-group");
                menuBlock.style.backgroundColor = "white";

            },
            unhighlightAllMenuItem: function (section) {
                console.log(`Secction Name: ${section}`);
                let menuBlocks = document.querySelectorAll("li[class$='-group nav-item']");
                if (menuBlocks.length > 0) {
                    menuBlocks.forEach(val => {
                        val.style.backgroundColor = "transparent";
                    });
                }

            },
            tabClick(tab) {
                switch (tab) {
                    case 'LEADERSHIP_AND_ENGAGEMENT':
                      this.$router.push({
                        name: "SurveyLink",
                        params: {surveyKey: this.surveyKey, thePageId: '6409511e617e3d4abad4e893'}
                      });
                        break;

                    case 'ENERGY_EFFICIENCY':
                      this.$router.push({
                        name: "SurveyLink",
                        params: {surveyKey: this.surveyKey, thePageId: '6409511e617e3d4abad4e89b'}
                      });
                      Bus.$emit('page-update', this.value[0].name);
                        break;

                    case 'WATER_EFFICIENCY':
                      this.$router.push({
                        name: "SurveyLink",
                        params: {surveyKey: this.surveyKey, thePageId: '6409511f617e3d4abad4e8c1'}
                      });
                      Bus.$emit('page-update', this.value[0].name);
                        break;
                    case 'WASTE_REDUCTION':
                      this.$router.push({
                        name: "SurveyLink",
                        params: {surveyKey: this.surveyKey, thePageId: '6409511e617e3d4abad4e89b'}
                      })
                            .then(val => {
                                Bus.$emit('page-update', this.value[0].name);
                            });
                        break;
                    case 'POLLUTION_PREVENTION':
                      this.$router.push({
                        name: "SurveyLink",
                        params: {surveyKey: this.surveyKey, thePageId: '6409511f617e3d4abad4e910'}
                      });
                      Bus.$emit('page-update', this.value[0].name);
                        break;
                    case 'EQUITY_AND_COMMUNITY':
                      this.$router.push({
                        name: "SurveyLink",
                        params: {surveyKey: this.surveyKey, thePageId: '64095120617e3d4abad4e92f'}
                      });
                      Bus.$emit('page-update', this.value[0].name);
                        break;
                    case 'STORM_AND_WASTE_WATER':
                      this.$router.push({
                        name: "SurveyLink",
                        params: {surveyKey: this.surveyKey, thePageId: '64095120617e3d4abad4e956'}
                      });
                      Bus.$emit('page-update', this.value[0].name);
                        break;
                    default:
                        this.closeAllSubmenus();
                        this.unhighlightAllMenuItem(tab);
                        this.highlightMenuItem(tab);
                        Bus.$emit('page-update', tab.toUpperCase().replace(" ", "_"));
                        break;
                }
            },
            subMenuClick(item) {
                let newPage = item;
                console.log("TabHeader: Sub Menu Go to Page: " + newPage);
                Bus.$emit('page-update', newPage);
            },
            hasSubSection: function (sectionName) {
                return ((sectionName !== 'LEADERSHIP_AND_ENGAGEMENT') && (sectionName !== 'STORM_AND_WASTE_WATER'));
            },
            tabTitle(title) {
                return `${title}`;
            }
        }
    }
</script>

<style>
    .leadership_and_engagement-group {
        color: #8A1F03;
    }

    .vue-icon path[pid='0'] {
        fill: #42b983;
    }

    .vue-icon path[pid='1'] {
        fill: #35495e;
    }

    .leadership_and_engagement {
        color: #8A1F03;
        font-size: 14px;
    }

    .energy_efficiency {
        color: rgb(222, 119, 43);
        font-size: 14px;
    }

    .water_efficiency {
        color: rgb(156, 192, 184);
        font-size: 14px;
    }

    .waste_reduction {
        color: rgb(226, 201, 70);
        font-size: 14px;
    }

    .pollution_prevention {
        color: rgb(167, 170, 97);
        font-size: 14px;
    }

    .equity_and_community {
        color: rgb(80, 92, 19);
        font-size: 14px;
    }

    .storm_and_waste_water {
        color: rgb(90, 117, 114);
        font-size: 14px;
    }

    .leadership_and_engagement_progress {
        background-color: #8A1F03;
    }

    .energy_efficiency_progress {
        background-color: rgb(222, 119, 43);
    }

    .water_efficiency_progress {
        background-color: rgb(156, 192, 184);
    }

    .waste_reduction_progress {
        background-color: rgb(226, 201, 70);
    }

    .pollution_prevention_progress {
        background-color: rgb(167, 170, 97);
    }

    .equity_and_community_progress {
        background-color: rgb(80, 92, 19);
        font-size: 14px;
    }

    .storm_and_waste_water_progress {
        background-color: rgb(90, 117, 114);
    }

    .leadership_and_engagement-line-item {
        color: #808080;
        padding-left: 40px;
        font-size: 13px;
    }

    .energy_efficiency-line-item {
        color: #808080;
        padding-left: 035px;
        font-size: 13px;
    }

    .water_efficiency-line-item {
        color: #808080;
        padding-left: 40px;
        font-size: 13px;
    }

    .waste_reduction-line-item {
        color: #808080;
        padding-left: 40px;
        font-size: 13px;
    }

    .pollution_prevention-line-item {
        color: #808080;
        padding-left: 40px;
        font-size: 13px;
    }

    .equity_and_community-line-item {
        color: #808080;
        padding-left: 40px;
        font-size: 13px;
    }

    .storm_and_waste_water-line-item {
        color: #808080;
        padding-left: 40px;
        font-size: 13px;
    }

    /* recommended css code for vue-svgicon */
    .svg-icon {
        display: inline-block;
        width: 16px;
        height: 16px;
        color: inherit;
        vertical-align: middle;
        fill: none;
        stroke: currentColor;
    }

    .svg-fill {
        fill: currentColor;
        stroke: none;
    }

    .svg-up {
        /* default */
        transform: rotate(0deg);
    }

    .svg-right {
        transform: rotate(90deg);
    }

    .svg-down {
        transform: rotate(180deg);
    }

    .svg-left {
        transform: rotate(-90deg);
    }

    .sub-menu {
        padding: 0px;
    }

    /* unvisited link */
    a:link {
        text-decoration: none;
    }

    /* visited link */
    a:visited {
        color: #808080;
    }

    /* mouse over link */
    a:hover {
        color: #333333;
    }

    /* selected link */
    a:active {
        color: #808080;
    }
</style>
